__turbopack_context__.v({
  "chevron": "ExpandableText-module-scss-module__aqmefG__chevron",
  "chevronUp": "ExpandableText-module-scss-module__aqmefG__chevronUp",
  "clamped": "ExpandableText-module-scss-module__aqmefG__clamped",
  "toggle": "ExpandableText-module-scss-module__aqmefG__toggle",
  "wrapper": "ExpandableText-module-scss-module__aqmefG__wrapper",
});
